import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Symbol } from "@faire/retailer-visitor-shared/components/Button/RoundButtonStyles";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Add } from "@faire/web--source/slate/icons/foundation/Add";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { Span } from "@faire/web--source/slate/Typography";
import ClickOutside from "@faire/web--source/ui/ClickOutside";
import React from "react";
import styled, { css } from "styled-components";
export var RoundMultiOptionPicker = function(param) {
    var value = param.value, onChooseMultiOption = param.onChooseMultiOption, size = param.size, maxWidth = param.maxWidth, multiOptionText = param.multiOptionText, textWidth = param.textWidth, showModalOnClick = param.showModalOnClick;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _React_useState = _sliced_to_array(React.useState(false), 2), expand = _React_useState[0], setExpand = _React_useState[1];
    var componentSize = getSpacing(size !== null && size !== void 0 ? size : "4x");
    var valueDisplay = null;
    if (value === 0 && !expand) {
        valueDisplay = /*#__PURE__*/ _jsx(Symbol, {
            "data-test-id": "round-multi-option-picker-add-symbol",
            children: /*#__PURE__*/ _jsx(Add, {})
        });
    } else if (expand) {
        valueDisplay = /*#__PURE__*/ _jsx(Span, {
            variant: "paragraphSansMedium",
            color: "inherit",
            truncate: true,
            children: multiOptionText
        });
    } else {
        valueDisplay = /*#__PURE__*/ _jsx(Span, {
            variant: "paragraphSansMedium",
            color: "inherit",
            truncate: true,
            children: value
        });
    }
    var buttonOnClick = function(e) {
        e.preventDefault();
        if (showModalOnClick) {
            onChooseMultiOption === null || onChooseMultiOption === void 0 ? void 0 : onChooseMultiOption();
        } else {
            if (expand) {
                onChooseMultiOption === null || onChooseMultiOption === void 0 ? void 0 : onChooseMultiOption();
                setExpand(false);
            } else {
                setExpand(true);
            }
        }
    };
    return /*#__PURE__*/ _jsx(ClickOutside, {
        onClickOutside: function() {
            return setExpand(false);
        },
        children: /*#__PURE__*/ _jsx(ButtonBase, {
            "data-test-id": "round-multi-option-picker",
            $isBase: value === 0 && !expand,
            $expand: expand,
            $textWidth: textWidth,
            $size: componentSize,
            onClick: function(e) {
                return buttonOnClick(e);
            },
            $maxWidth: maxWidth !== null && maxWidth !== void 0 ? maxWidth : 0,
            onMouseEnter: function() {
                return !showModalOnClick ? setExpand(true) : null;
            },
            onMouseLeave: function() {
                return setExpand(false);
            },
            "aria-label": strictLocalize({
                id: "RsX9/7",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Open quick add modal"
                    }
                ]
            }),
            children: valueDisplay
        })
    });
};
var ButtonBase = styled.button.withConfig({
    componentId: "sc-a007f1fb-0"
})([
    "display:flex;align-items:center;justify-content:center;padding-left:",
    ";padding-right:",
    ";font-size:16px;height:",
    ";background-color:",
    ";transition:all 150ms linear;width:",
    ";border-radius:16px;color:",
    ";",
    ";"
], function(props) {
    return props.$expand ? "16px" : "0px";
}, function(props) {
    return props.$expand ? "16px" : "0px";
}, function(props) {
    return props.$size;
}, function(props) {
    return props.$isBase ? Core.surface.inverse : Core.surface.default;
}, function(props) {
    return(// eslint-disable-next-line no-nested-ternary
    props.$expand ? css([
        "",
        "px"
    ], props.$maxWidth) : props.$isBase ? props.$size : css([
        "",
        "px"
    ], props.$textWidth));
}, function(props) {
    return props.$isBase ? Core.surface.default : Core.border.muted;
}, function(param) {
    var $isBase = param.$isBase;
    return $isBase ? css([
        "&:hover{background-color:",
        ";color:",
        ";}"
    ], Core.surface.default, Core.border.muted) : null;
});
